import React from "react";
import { LayoutHome } from "./LayoutHome";
import { useState, useRef, useEffect } from "react";
import { Input, notification, Splitter, Button } from "antd";
import {
  Col,
  Panel,
  Row,
  Text,
  Box,
  SelectPicker,
  Modal,
  toaster,
  Message,
} from "rsuite";
import Table from "react-bootstrap/Table";
import {
  getTurnos,
  getHorariosTurno,
  getInsumosSesion,
} from "./Services/SesionHemoServices";
import {
  getPacientesSesion,
  getDataFiltro,
  getDatospaciente,
  getAccesoVascular,
} from "./Services/HojaEnfermeria";
import {
  inicioNotaMedica,
  getDataFromHE,
  getDatosNotaMedica,
  saveCampo,
  saveFirmaNota,
} from "./Services/NotaMedica";
import { confApp } from "../CONF_APP";
import SignatureCanvas from "react-signature-canvas";
import { soloNumeros } from "../Utils";
import {
  Check,
  DoorClosed,
  Eraser,
  LucideAArrowDown,
  PlusCircleIcon,
  RefreshCcw,
  Save,
} from "lucide-react";
import { DownloadOutlined } from "@ant-design/icons";

const { TextArea } = Input;

export const NotaMedica = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedico,
  );
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const nombreUser = JSON.parse(localStorage.getItem("auth")).nombre;
  const fechaLarga = JSON.parse(localStorage.getItem("auth")).confApp.fechas
    .fechaLarga;

  const fechaHora = JSON.parse(
    localStorage.getItem("auth"),
  ).confApp.fechas.fechaHora.toUpperCase();

  const [fecha] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.fechas.fechaFmtUsa,
  );

  const [idNota, setIdNota] = useState(0);
  const [idSesion, setIdSesion] = useState(0);
  const [fechaNota, setFechaNota] = useState("");
  const [estatusNota, setEstatusNota] = useState("En Sesion");
  const [nombre, setNombre] = useState("");
  const [paciente, setPaciente] = useState("");
  const [edad, setEdad] = useState("");
  const [sexo, setSexo] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [dataTurnos, setDataTurnos] = useState([]);
  const [dataHorarios, setDataHorarios] = useState([]);
  const [idTurno, setIdTurno] = useState(0);
  const [hora, setHora] = useState("");
  const [idPaciente, setIdPaciente] = useState(0);
  const [dataPacientes, setDataPacientes] = useState([]);
  const [filtro, setFiltro] = useState({});
  const [idFiltro, setIdFiltro] = useState("");
  const [tipoDial, setTipoDial] = useState("");
  const [pesoSeco, setPesoSeco] = useState(0);
  const [dataAccesoVasc, setADataccesoVasc] = useState([]);
  const [idAccesoVasc, setIdAccesoVasc] = useState(0);
  const [pesoIngreso, setPesoIngreso] = useState(0);
  const [tiempoDial, setTiempoDial] = useState("");
  const [uf, setUf] = useState(0);
  const [perfilNa, setPerfilNa] = useState("0");
  const [perfilUf, setPerfilUf] = useState("0");
  const [heparinaBolo, setHeparinaBolo] = useState(0);
  const [infusion, setInfusion] = useState(0);
  const [dataTotalHep] = useState(confApp.VALORES_HEPARINA_BOLO);
  const [dataPErfilUfNa] = useState(confApp.PERFIL_UF_NA);
  const [dataAcido] = useState(confApp.LISTA_ACIDO);
  const [fd, setFd] = useState(0);
  const [fs, setFs] = useState(0);
  const [Na, setNa] = useState(0);
  const [acido, setAcido] = useState(0);
  const [listInsumos, setListInsumos] = useState([]);
  const [ef, setEF] = useState("");
  const [evolSesion, setEvolSesion] = useState("");
  const [estadoPac, setEstadoPac] = useState("");
  const [observa, setObserva] = useState("");
  const [uft, setUft] = useState(0);
  const [vsp, setVsp] = useState(0);
  const [pesoFinal, setPesoFinal] = useState(0);
  const [dataFirma, setDataFirma] = useState("");
  const [imageFirmaDr, setImageFirmaDr] = useState(null);
  const [loadFirmaDr, setLoadFirmaDr] = useState(null);
  const [openModalInicia, setOpenModalInicia] = useState(false);
  const [openModalFirma, setOpenModalFirma] = useState(false);
  const [loadingInicio, setLoadingInicio] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const [imageFirma, setImageFirma] = useState(null);
  const [loadFirma, setLoadFirma] = useState(null);

  const handleCloseModalInicia = () => {
    setOpenModalInicia(false);
  };

  const signCanvas = useRef({});

  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);
  const modal = useRef();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const loadInsumos = async (idSes) => {
    await getInsumosSesion(idNegocio, idSes)
      .then(async (res) => {
        setListInsumos(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const clear = () => signCanvas.current.clear();

  const saveSignature = () => {
    if (signCanvas.current) {
      const data = signCanvas.current.toDataURL("image/png");
      setImageFirma(data);
      saveFirma(data);
    }
  };

  const saveFirma = async (firma) => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      idHoja: idNota,
      firmaEnf: firma,
      firmaPac: "",
    };
    await saveFirmaNota(data)
      .then((res) => {
        setEstatusNota(res.data);
        setOpenModalFirma(false);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleCloseModalFirma = () => {
    setOpenModalFirma(false);
  };

  const loadTurnos = async () => {
    await getTurnos(idNegocio)
      .then((res) => {
        setDataTurnos(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadAccesoVascular = async () => {
    await getAccesoVascular(idNegocio)
      .then((res) => {
        setADataccesoVasc(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleAccesoVasc = (e) => {
    setIdAccesoVasc(e);
    if (e !== null) {
      const obj = {
        target: {
          value: e,
        },
      };
      updateCampo("accesoVasc", obj);
    }
  };

  const fetchHorarios = async (e) => {
    if (e === null) {
      setDataHorarios([]);
      return;
    }

    setIdTurno(e);
    await getHorariosTurno(idNegocio, e)
      .then(async (res) => {
        setDataHorarios(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadPacientes = async (e) => {
    if (e === null) {
      setDataPacientes([]);
      return;
    }

    setHora(e);
    await getPacientesSesion(idNegocio, 0, fecha, e)
      .then((res) => {
        setDataPacientes(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const handleObtenerDatosSesion = async () => {
    setLoadingData(true);
    await getDataFromHE(idNegocio, idSesion)
      .then((res) => {
        if (res === "") {
          errorNotificaction(
            "Datos HE",
            "No existe información de la Hoja de Enfermería.",
          );
        }
        setUft(res.uft);
        setVsp(res.vsp);
        setPesoFinal(res.pesoFinal);
        setEstatusNota(res.estatus);
        setLoadingData(false);
      })
      .catch((err) => {
        setLoadingData(false);
        errorNotificaction(err.name, err.message);
      });
  };

  const updateCampo = async (campo, e) => {
    const data = {
      id: idNegocio,
      idNota: idNota,
      campo: campo,
      valor: e.target ? e.target.value : e,
    };

    await saveCampo(data)
      .then((res) => {
        if (res.data === -1) {
          return;
        }
        toast("El dato se ha actualizado de forma correcta.", "success");
        setEstatusNota(res.data);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const calculaEdad = (e) => {
    const hoy = new Date(); // Fecha actual
    const fechaNac = new Date(e); // Fecha de nacimiento del input

    let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();

    // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
    if (mesActual < mesNac) {
      edad--;
    } else if (mesActual === mesNac) {
      // Si los meses son iguales, revisamos el día
      const diaActual = hoy.getDate();
      const diaNac = fechaNac.getDate();
      if (diaActual < diaNac) {
        edad--; // No ha cumplido años aún en el mes actual
      }
    }

    // Para obtener meses y días exactos (más complejo, pero posible)
    // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
    // El método anterior solo da los años cumplidos.
    setEdad(edad);
  };

  const maskTime = (value, opc) => {
    if (opc === "tiempoDial") {
      setTiempoDial(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
  };

  const handleInfusion = (e) => {
    if (e === null) {
      setInfusion(0);
    }
    setInfusion(e);
    const obj = {
      target: {
        value: e,
      },
    };
    updateCampo("infusion", obj);
  };

  const handleHeparinaBolo = (e) => {
    if (e === null) {
      setHeparinaBolo(0);
      e = 0;
    }
    setHeparinaBolo(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("heparinaBolo", obj);
  };

  const handleObserva = (e) => {
    setObserva(e.target.value);
    updateCampo("observa", e);
  };

  const handleUpdatePerfilNa = (e) => {
    if (e === null) {
      setPerfilNa(0);
      e = 0;
    }
    setPerfilNa(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("perfilNa", obj);
  };

  const handleUpdatePerfilUF = (e) => {
    if (e === null) {
      setPerfilUf(0);
      e = 0;
    }
    setPerfilUf(e);

    const obj = {
      target: {
        value: e,
      },
    };

    updateCampo("perfilUf", obj);
  };

  const handleFocus = (event) => event.target.select();

  const handleEF = (e) => {
    setEF(e.target.value);
  };

  const handleEvolSesion = (e) => {
    setEvolSesion(e.target.value);
  };

  const handleEstadoPac = (e) => {
    setEstadoPac(e.target.value);
  };

  const handleOpenModalFirma = () => {
    if (estatusNota === "Cerrada") {
      setDataFirma(`Firma del Médico`);
      setOpenModalFirma(true);
    } else {
      errorNotificaction(
        "Validación de cierre",
        `No es posible abrir el modal de firma, revise que toda la información este completa.`,
      );
    }
  };

  const loadInicioNota = async (props) => {
    const data = {
      id: idNegocio,
      idSesion: props.idSesion,
      idNota: 0,
      idPaciente: props.idPaciente,
      idFiltro: props.idFiltro,
      idMedico: idMedico,
      pesoInicio: props.pesoInicio,
    };

    await inicioNotaMedica(data)
      .then(async (res) => {
        if (res.status === 200) {
          successNotification(
            "Nota médica",
            "Nota médica iniciada correctamente.",
          );

          setIdNota(res.data.idNota);
          setIdSesion(res.data.idSesion);
          setEstatusNota(res.data.estatus);
          setFechaNota(res.data.fecha);
          await getDatosNotaMedica(idNegocio, res.data.idNota)
            .then((res) => {
              setDiagnostico(res.diagnostico);
              setPesoSeco(res.pesoSeco);
              setIdAccesoVasc(String(res.idAccesoVasc));
              setPesoIngreso(res.pesoInicio);
              setTiempoDial(res.tiempo);
              setUf(res.uf);
              setFd(res.fd);
              setFs(res.fs);
              setNa(res.Na);
              setAcido(res.acido);
              setPerfilNa(String(res.perfilNa));
              setPerfilUf(String(res.perfilUf));
              setHeparinaBolo(String(res.hepaBolo));
              setInfusion(String(res.infusion));
              setEvolSesion(res.evol);
              setEF(res.explora);
              setEstadoPac(res.estadoPac);
              setUft(res.uft);
              setVsp(res.vsp);
              setPesoFinal(res.pesoFinal);
              setObserva(res.observa);
              setLoadFirma(res.firma);
              setEstatusNota(res.estatus);
            })
            .then(async () => {
              setOpenModalInicia(false);
              await loadAccesoVascular().then(async () => {
                loadInsumos(props.idSesion)
                  .then(() => {
                    setLoadingInicio(false);
                  })
                  .catch((err) => {
                    errorNotificaction(err.name, err.message);
                  });
              });
            })
            .catch((err) => {
              setLoadingInicio(false);
              errorNotificaction(err.name, err.message);
            });
        } else {
          setLoadingInicio(false);
          errorNotificaction("Error", "No se pudo iniciar la nota médica.");
        }
      })
      .catch((err) => {
        setLoadingInicio(false);
        errorNotificaction(err.name, err.message);
      });
  };

  const openModalInicio = (e) => {
    const selectedItem = dataPacientes.find((item) => item.value === e);
    setIdPaciente(e);
    setPaciente(selectedItem.label);
    setOpenModalInicia(true);
  };

  const handleIniciaNota = async () => {
    var _idSesion = 0;
    var _idFiltro = "";
    var _pesoIngreso = 0;
    setImageFirma(null);
    setLoadFirma(null);
    setLoadingInicio(true);

    await getDatospaciente(idNegocio, idPaciente, fecha, hora)
      .then((res) => {
        _idSesion = res.idSesion;
        setIdSesion(res.idSesion);
        setNombre(res.nombre);
        setSexo(res.genero);
        let _fecha = res.fechaNac;
        if (_fecha !== null) {
          var _fecNac = new Date(res.fechaNac);
          _fecNac.setDate(_fecNac.getDate() + 1);
          calculaEdad(_fecNac);
        } else {
          setEdad(0);
        }
        setIdFiltro(res.idFiltro);
        _idFiltro = res.idFiltro;
        _pesoIngreso = res.pesoInicial;
        setPesoIngreso(res.pesoInicial);
      })
      .then(async () => {
        await getDataFiltro(idNegocio, _idFiltro).then((res) => {
          setFiltro(res);
          loadInicioNota({
            idSesion: _idSesion,
            idPaciente: idPaciente,
            idFiltro: _idFiltro,
            pesoInicio: _pesoIngreso,
          });
        });
      })
      .catch((error) => {
        setLoadingInicio(false);
        errorNotificaction(error.name, error.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadTurnos();
    }
  }, []);

  return (
    <>
      <title>Nota Médica - Nefrosys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Nota Médica" },
        ]}
        selectedKey={"notaMedica"}
      >
        {contextHolder}
        <Panel bordered>
          <Row>
            <Col span={4}>
              <Text weight="bold">Fecha: {fechaLarga}</Text>
            </Col>
            <Col
              span={16}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Text size="lg" weight="bold">
                INDICACIONES MEDICAS Y NOTA MEDICA
              </Text>
            </Col>
            <Col
              span={4}
              style={{
                display: "flex",
                justifyContent: "right",
                textAlign: "right",
              }}
            >
              <Box
                mb={2}
                bd="1px solid var(--rs-border-primary)"
                rounded="lg"
                style={{ padding: "5px" }}
              >
                <Text size={"lg"} weight="semibold">
                  Folio No. {idNota > 0 ? idNota : "000000"}
                </Text>
              </Box>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <Text weight="semibold">Turno</Text>
              <SelectPicker
                placeholder="--Selecciona--"
                searchable={false}
                data={dataTurnos}
                onChange={(e) => fetchHorarios(e)}
                block
              />
            </Col>
            <Col span={3}>
              <Text size={"sm"} weight="semibold">
                Horario
              </Text>
              <SelectPicker
                block
                searchable={false}
                value={hora}
                data={dataHorarios}
                placeholder="--Horario--"
                onChange={(e) => loadPacientes(e)}
              />
            </Col>
          </Row>
        </Panel>
        <Row>
          <Col span={24}>
            <Table bordered style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>NOMBRE:</th>
                  <th style={{ width: "70%" }}>
                    <SelectPicker
                      block
                      value={idPaciente}
                      data={dataPacientes}
                      placeholder="-- SELECCIONA --"
                      onChange={(e) => {
                        openModalInicio(e);
                      }}
                    />
                  </th>
                  <th style={{ width: "10%" }}>EDAD:</th>
                  <th style={{ width: "30%", textAlign: "center" }}>
                    {edad} años
                  </th>
                </tr>
                <tr>
                  <th>DIAGNÓSTICO:</th>
                  <th>
                    <Input
                      placeholder="Diagnóstico"
                      disabled={idNota > 0 ? false : true}
                      value={diagnostico}
                      onBlur={(e) => updateCampo("diagnostico", e)}
                      onChange={(e) => setDiagnostico(e.target.value)}
                    />
                  </th>
                  <th>SEXO:</th>
                  <th style={{ width: "30%", textAlign: "center" }}>{sexo}</th>
                </tr>
              </thead>
            </Table>
          </Col>
        </Row>
        <Panel bordered>
          <Row>
            <Col span={24}>
              <Splitter style={{ overflowX: "hidden" }}>
                <Splitter.Panel
                  style={{ padding: "2px", overflowX: "hidden" }}
                  defaultSize="50%"
                  min="40%"
                  max="80%"
                >
                  <Table bordered style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          colSpan={4}
                          style={{ textAlign: "center", fontSize: "20px" }}
                        >
                          INDICACIONES MÉDICAS
                        </th>
                      </tr>
                      <tr>
                        <th>FECHA Y HORA:</th>
                        <th colSpan={3} style={{ textAlign: "center" }}>
                          {fechaNota.toUpperCase()}
                        </th>
                      </tr>
                      <tr>
                        <th>FILTRO:</th>
                        <th style={{ textAlign: "center" }}>
                          {filtro.clasifica}
                        </th>
                        <th>P. SECO:</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            placeholder="0 Kg"
                            disabled={idNota > 0 ? false : true}
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={pesoSeco}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("pesoSeco", e)}
                            onChange={(e) => setPesoSeco(soloNumeros(e))}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>ACCESO:</th>
                        <th style={{ textAlign: "center" }}>
                          <SelectPicker
                            size="sm"
                            searchable={false}
                            placeholder="-"
                            disabled={
                              idNota > 0
                                ? estatusNota === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            data={dataAccesoVasc}
                            value={idAccesoVasc}
                            onChange={(e) => handleAccesoVasc(e)}
                            block
                          />
                        </th>
                        <th>P. INICIO</th>
                        <th>
                          <Input
                            size="small"
                            placeholder="0 Kg"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={pesoIngreso}
                            disabled={idNota > 0 ? false : true}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("pesoIngreso", e)}
                            onChange={(e) => setPesoIngreso(soloNumeros(e))}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>TIEMPO:</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            placeholder="HH:mm (Horas y minutos)"
                            maxLength={5}
                            size="small"
                            disabled={idNota > 0 ? false : true}
                            value={tiempoDial}
                            onBlur={(e) => updateCampo("tiempoDial", e)}
                            onChange={(e) =>
                              maskTime(e.target.value, "tiempoDial")
                            }
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                          />
                        </th>
                        <th>UF:</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            placeholder="UF"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={uf}
                            disabled={idNota > 0 ? false : true}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("uf", e)}
                            onChange={(e) => setUf(soloNumeros(e))}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>FD:</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            placeholder="FD"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={fd}
                            disabled={idNota > 0 ? false : true}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("fd", e)}
                            onChange={(e) => setFd(soloNumeros(e))}
                          />
                        </th>
                        <th>PERFIL UF:</th>
                        <th style={{ textAlign: "center" }}>
                          <SelectPicker
                            value={perfilUf}
                            disabled={
                              idNota > 0
                                ? estatusNota === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            size="small"
                            placeholder="--SELECCIONA--"
                            block
                            data={dataPErfilUfNa}
                            onChange={(e) => handleUpdatePerfilUF(e)}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>FS:</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            placeholder="FS"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={fs}
                            disabled={idNota > 0 ? false : true}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("fs", e)}
                            onChange={(e) => setFs(soloNumeros(e))}
                          />
                        </th>
                        <th>PERFIL Na:</th>
                        <th>
                          <SelectPicker
                            value={perfilNa}
                            disabled={
                              idNota > 0
                                ? estatusNota === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            size="small"
                            data={dataPErfilUfNa}
                            placeholder="--SELECCIONA--"
                            block
                            onChange={(e) => handleUpdatePerfilNa(e)}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>HEPARINA BOLO:</th>
                        <th>
                          <SelectPicker
                            searchable={false}
                            disabled={
                              idNota > 0
                                ? estatusNota === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            block
                            data={dataTotalHep}
                            size="sm"
                            placeholder="--SELECCIONA--"
                            value={heparinaBolo}
                            onChange={(e) => handleHeparinaBolo(e)}
                          />
                        </th>
                        <th>NA:</th>
                        <th style={{ textAlign: "center" }}>
                          <Input
                            size="small"
                            placeholder="NA"
                            style={{
                              textAlign: "center",
                              backgroundColor: "#E7FBFE",
                            }}
                            value={Na}
                            disabled={idNota > 0 ? false : true}
                            onFocus={handleFocus}
                            onBlur={(e) => updateCampo("Na", e)}
                            onChange={(e) => setNa(soloNumeros(e))}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th>HEP INFUSIÓN:</th>
                        <th>
                          <SelectPicker
                            searchable={false}
                            disabled={
                              idNota > 0
                                ? estatusNota === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            block
                            data={dataTotalHep}
                            size="sm"
                            placeholder="--SELECCIONA--"
                            value={infusion}
                            onChange={(e) => handleInfusion(e)}
                          />
                        </th>
                        <th>ACIDO:</th>
                        <th style={{ textAlign: "center" }}>
                          <SelectPicker
                            searchable={false}
                            disabled={
                              idNota > 0
                                ? estatusNota === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            block
                            data={dataAcido}
                            size="sm"
                            placeholder="--SELECCIONA--"
                            value={acido}
                            onChange={(e) => {
                              setAcido(e);
                              const obj = {
                                target: { value: e },
                              };
                              updateCampo("acido", obj);
                            }}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th
                          colspan={4}
                          style={{ textAlign: "center", fontSize: "18px" }}
                        >
                          Medicamentos
                        </th>
                      </tr>
                    </thead>
                    {listInsumos.length > 0 ? (
                      <tbody>
                        {listInsumos.map((item, index) => {
                          return (
                            <tr key={`row-${index}`}>
                              <td style={{ textAlign: "center" }}>
                                {item.cantidad}
                              </td>
                              <td colspan={2}>{item.insumo}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.hora}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : (
                      ""
                    )}
                  </Table>
                </Splitter.Panel>
                <Splitter.Panel
                  style={{ padding: "2px", overflowX: "hidden" }}
                  defaultSize="50%"
                  min="40%"
                  max="80%"
                >
                  <Table bordered style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          colSpan={7}
                          style={{ textAlign: "center", fontSize: "20px" }}
                        >
                          NOTA MÉDICA
                        </th>
                      </tr>
                      <tr>
                        <th
                          style={{
                            verticalAlign: "top",
                            fontSize: "16px",
                            width: "40%",
                          }}
                        >
                          <u>EF a su ingreso:</u>
                        </th>
                        <th colspan={6}>
                          <TextArea
                            disabled={idNota > 0 ? false : true}
                            rows={4}
                            value={ef}
                            placeholder=""
                            onBlur={(e) =>
                              updateCampo("exploraFis", {
                                target: {
                                  value: e.target.value,
                                },
                              })
                            }
                            style={{
                              backgroundColor: "#E7FBFE",
                            }}
                            onChange={(e) => handleEF(e)}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th style={{ verticalAlign: "top", fontSize: "16px" }}>
                          <u>Evolución en la sesión de hemodiálisis:</u>
                        </th>
                        <th colspan={6}>
                          <TextArea
                            disabled={idNota > 0 ? false : true}
                            rows={4}
                            value={evolSesion}
                            placeholder=""
                            onBlur={(e) =>
                              updateCampo("evolSesion", {
                                target: {
                                  value: e.target.value,
                                },
                              })
                            }
                            style={{
                              backgroundColor: "#E7FBFE",
                            }}
                            onChange={(e) => handleEvolSesion(e)}
                          />
                        </th>
                      </tr>
                      <tr>
                        <th style={{ verticalAlign: "top", fontSize: "16px" }}>
                          <u>Estado del paciente a su egreso:</u>
                        </th>
                        <th colspan={6}>
                          <TextArea
                            disabled={idNota > 0 ? false : true}
                            rows={4}
                            value={estadoPac}
                            placeholder=""
                            onBlur={(e) =>
                              updateCampo("estadoPac", {
                                target: {
                                  value: e.target.value,
                                },
                              })
                            }
                            style={{
                              backgroundColor: "#E7FBFE",
                            }}
                            onChange={(e) => handleEstadoPac(e)}
                          />
                        </th>
                      </tr>
                      <tr style={{ height: "70px", verticalAlign: "center" }}>
                        <th
                          style={{
                            textAlign: "center",
                            verticalAlign: "center",
                          }}
                        >
                          <Button
                            block
                            disabled={
                              idNota > 0
                                ? estatusNota === "Finalizada"
                                  ? true
                                  : false
                                : true
                            }
                            loading={loadingData}
                            icon={<DownloadOutlined></DownloadOutlined>}
                            onClick={handleObtenerDatosSesion}
                          >
                            Obtener datos de la sesión
                          </Button>
                        </th>
                        <th style={{ fontSize: "16px", verticalAlign: "top" }}>
                          UFT:
                        </th>
                        <th
                          style={{ textAlign: "center", verticalAlign: "top" }}
                        >
                          {uft}
                        </th>
                        <th style={{ fontSize: "16px", verticalAlign: "top" }}>
                          VSP:
                        </th>
                        <th
                          style={{ textAlign: "center", verticalAlign: "top" }}
                        >
                          {vsp}
                        </th>
                        <th style={{ fontSize: "16px", verticalAlign: "top" }}>
                          <u>Peso al final:</u>
                        </th>
                        <th
                          style={{ textAlign: "center", verticalAlign: "top" }}
                        >
                          {pesoFinal}
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </Splitter.Panel>
              </Splitter>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <TextArea
                disabled={idSesion > 0 ? false : true}
                rows={2}
                value={observa}
                placeholder="Observaciones"
                onBlur={(e) =>
                  updateCampo("observa", {
                    target: {
                      value: e.target.value,
                    },
                  })
                }
                style={{
                  backgroundColor: "#E7FBFE",
                }}
                onChange={(e) => setObserva(e.target.value)}
              />
            </Col>
          </Row>
          <div className="row mb-1">
            {imageFirmaDr && (
              <div className="text-center col-lg-6 col-md-6 col-sm-6">
                <img
                  src={imageFirmaDr}
                  alt="signature"
                  style={{ height: "200px", width: "auto", padding: "10px" }}
                />
              </div>
            )}
            {loadFirmaDr && imageFirmaDr === null && (
              <div className="text-center col-lg-6 col-md-6 col-sm-6">
                <img
                  src={`Unidades/${idNegocio}/Sesiones/${idSesion}/${idNota}/${loadFirmaDr}`}
                  alt="signature"
                  style={{ height: "200px", width: "auto", padding: "10px" }}
                />
              </div>
            )}
          </div>
          <div className="row">
            <br></br>
          </div>
          <div className="row mb-1">
            {imageFirma && (
              <div className="text-center col-lg-6 col-md-6 col-sm-6">
                <img
                  src={imageFirma}
                  alt="signature"
                  style={{ height: "200px", width: "auto", padding: "10px" }}
                />
              </div>
            )}
            {loadFirma && imageFirma === null && (
              <div className="text-center col-lg-6 col-md-6 col-sm-6">
                <img
                  src={`Unidades/${idNegocio}/Sesiones/${idSesion}/FirmaNotaMedica/${loadFirma}`}
                  alt="signature"
                  style={{ height: "200px", width: "auto", padding: "10px" }}
                />
              </div>
            )}
          </div>
          <div className="row">
            <div className="text-center col-lg-6 col-md-6">
              <Text weight="semibold">{nombreUser}</Text>
              <Button
                color="default"
                variant="outlined"
                disabled={
                  idNota > 0
                    ? estatusNota === "Finalizada"
                      ? true
                      : false
                    : true
                }
                block
                onClick={handleOpenModalFirma}
              >
                Firma del médico responsable
              </Button>
            </div>
          </div>
        </Panel>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL INICIO DE SESION <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size={"sm"}
          open={openModalInicia}
          onClose={handleCloseModalInicia}
        >
          <Modal.Header>
            <Modal.Title>Inicio Nota Médica</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel>
              <div className="row mb-3">
                <div className="col">
                  <Text weight="semibold" size={"xxl"}>
                    ¿Desea iniciar la sesión del paciente? <br></br>
                    {paciente}
                  </Text>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Text size={"md"} color={"red"}>
                    * Para grabar información en la hoja: <br></br>
                    Debes ingresar al campo y presionar la tecla <b>Tab</b>
                  </Text>
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              icon={<DoorClosed></DoorClosed>}
              color="default"
              variant="solid"
              onClick={handleCloseModalInicia}
            >
              Cerrar
            </Button>
            <Button
              icon={<Check></Check>}
              type="primary"
              onClick={handleIniciaNota}
              loading={loadingInicio}
            >
              Inciar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL FIRMAS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size={"md"}
          open={openModalFirma}
          onClose={handleCloseModalFirma}
        >
          <Modal.Header>
            <Modal.Title>Firma del Médico</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <SignatureCanvas
                ref={signCanvas}
                canvasProps={{
                  style: { width: "100%", minHeight: "376px" },
                }}
              />
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button
              icon={<Eraser></Eraser>}
              color="default"
              variant="solid"
              onClick={clear}
            >
              Borrar
            </Button>
            <Button
              icon={<Save size={16}></Save>}
              type="primary"
              onClick={saveSignature}
            >
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      </LayoutHome>
    </>
  );
};
